import { useMemo } from 'react';
import { useFilterContext } from '../context';
import { useFavouriteStations } from 'entities/stations';

import { EMPTY_ARRAY } from 'common/constants';

export const useFilteredFavouriteStations = () => {
  const { searchString } = useFilterContext();
  const favouriteStations = useFavouriteStations() || EMPTY_ARRAY;

  const filteredFavouriteStations = useMemo(() => (
    favouriteStations.filter(({ stationCode = '', brandName }) => {
      const trimedSearchString = searchString.toLowerCase().trim();
      return stationCode.toLowerCase().includes(trimedSearchString) || (brandName || '').toLowerCase().includes(trimedSearchString);
    })
  ), [
    favouriteStations,
    searchString
  ]);

  return filteredFavouriteStations;
};
